<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000" persistent scrollable>
      <v-card>
        <v-card-title>
          Selectionner des utilisateurs
          <v-spacer/>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>

        <v-card-text class="pa-10">
          <v-tabs v-model="tab"
                  color="gifty"
                  centered
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab tab-value="tab-1">
              <v-icon left dense>mdi-filter-outline</v-icon>
              Filtrage
            </v-tab>

            <v-tab tab-value="tab-2">
              <v-icon left dense>mdi-account-multiple-outline</v-icon>
              Utilisateurs
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-card>
                <v-card-text>
                  <form @submit.prevent="filterUsers">

                    <v-row>
                      <v-col cols="6">
                        <v-select outlined
                                  dense

                                  label="Versions"
                                  :loading="isVersionsLoading"
                                  :items="versions"
                                  multiple
                                  v-model="filter.versions"
                                  class="mb-3"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  label="Pays"
                                  :loading="isDBLoading"
                                  :items="countries"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  v-model="filter.countries"
                                  class="mb-3"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete outlined
                                        dense
                                        hide-details
                                        label="Wilaya"
                                        clearable
                                        chips
                                        small-chips
                                        deletable-chips
                                        multiple
                                        v-model="filter.selectedWilayas"
                                        @change="filterRegion"
                                        :items="$store.state.wilayas"
                                        item-value="id"
                                        item-text="name"
                                        class="mb-3"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete outlined
                                        dense
                                        class="mb-3"
                                        hide-details
                                        label="Commune"
                                        :disabled="filter.selectedWilayas?.length === 0"
                                        clearable
                                        chips
                                        small-chips
                                        deletable-chips
                                        multiple
                                        v-model="filter.selectedCommunes"
                                        :items="communes"
                                        item-value="id"
                                        item-text="name"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  label="Base de données"
                                  :loading="isDBLoading"
                                  :items="databases"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  v-model="filter.databases"
                                  class="mb-3"
                                  hide-details=""
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select outlined
                                  dense
                                  label="Catégories"
                                  :loading="isCategoryLoading"
                                  :items="categories"
                                  item-value="id"
                                  item-text="name"
                                  multiple
                                  v-model="filter.categories"
                                  class="mb-3"
                                  hide-details
                                  clearable
                                  chips
                                  small-chips
                                  deletable-chips
                        />
                      </v-col>

                    </v-row>


                    <div class="text-center  mt-5">
                      <v-btn depressed
                             color="gifty"
                             class="white--text"
                             type="submit"
                             :disabled="!filter.databases?.length"
                             :loading="btnLoading"
                      >
                        <v-icon left>mdi-magnify</v-icon>
                        Recherche
                      </v-btn>
                    </div>
                  </form>
                </v-card-text>

              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-card>
                <v-card-title>
                  <div>
                    <v-text-field outlined
                                  dense
                                  rounded
                                  hide-details
                                  clearable
                                  placeholder="Recherche"
                                  v-model="search"
                                  prepend-inner-icon="mdi-magnify"></v-text-field>
                  </div>
                  <v-spacer/>
                </v-card-title>
                <v-card-text>
                  <div v-if="isLoading">
                    <v-skeleton-loader type="table"></v-skeleton-loader>
                  </div>

                  <div v-else>
                    <div v-if="filtredUsers.length > 0">
                      <v-data-table :search="search"
                                    :items="filtredUsers"
                                    :headers="headers"
                                    v-model="selectedUsers"
                                    show-select
                                    checkbox-color="success"
                                    class="elevation-0 table-border rounded-lg"
                      >
                      </v-data-table>
                    </div>

                    <div v-else>
                      <div class="text-center">
                        <v-avatar tile size="200">
                          <v-img
                              :src="require('@/assets/database.svg')"
                          ></v-img>
                        </v-avatar>
                        <h3 class="text--primary d-block mb-2">OOPS !</h3>
                        <p>Aucun enregistrement correspondant trouvé.</p>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider/>

        <v-card-actions>

          <v-spacer/>

          <v-btn color="success"
                 :disabled="!selectedUsers.length"
                 depressed
                 @click="Validate">
            <v-icon left>mdi-check-circle</v-icon>
            Valider ({{ selectedUsers.length }})
          </v-btn>


        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      search: null,
      tab: "tab-1",
      btnLoading: false,
      isLoading: false,

      isDBLoading: false,
      isRoleLoading: false,
      isCategoryLoading: false,
      isCountriesLoading: false,
      isVersionsLoading: false,


      countries: [],
      roles: [],
      categories: [],
      databases: [],
      versions: [],

      max: 1000,

      headers: [
        {text: 'Nom', value: 'name'},
        {text: 'Téléphone', value: 'phone'},
        {text: 'Email', value: 'email'},
        {text: 'Wilaya', value: 'wilaya.name'},
      ],

      filter: {
        selectedWilayas: [],
        selectedCommunes: [],
        countries: [],
        roles: [],
        categories: [],
        databases: [],
        versions: [],
        range: [],
      },
      dialog: false,
      filtredUsers: [],

      selectedUsers: [],
      ids: [],
    };
  },
  methods: {
    filterUsers() {
      this.btnLoading = true;
      this.isLoading = true;
      //filter_users
      HTTP.post("/V2/publicities/filter_users", this.filter)
          .then((res) => {
            this.btnLoading = false;
            this.isLoading = false;
            this.selectedUsers = res.data.users;
            this.filtredUsers = res.data.users;
            this.ids = res.data.ids;
            this.tab = "tab-2"
          })
          .catch((err) => {
            this.btnLoading = false;
            this.isLoading = false;
            this.formErrors = err.response.data.errors;
          });
    },
    open(filter = null) {
      if (filter) {
        this.filter = filter;
      } else {
        this.filter = {
          selectedWilayas: [],
          selectedCommunes: [],
          countries: [],
          roles: [],
          categories: [],
          databases: [],
          versions: [],
          range: [],
        }
      }
      this.dialog = true;
      if (this.wilayas.length == 0) this.$store.dispatch("fetchwilayas");

      if (!this.roles.length) {
        this.getRoles();
      }
      if (!this.databases.length) {
        this.getDatabases();
      }

      if (!this.categories.length) {
        this.getCategories();
      }
      if (!this.countries.length) {
        this.getCountries();
      }
      if (!this.versions.length) {
        this.getVersions();
      }

    },
    close() {
      this.dialog = false;
    },

    Validate() {
      this.dialog = false;
      var ids = [];
      this.selectedUsers.forEach((element) => {
        ids.push(element.id);
      });


      this.$emit("selected", {
        users: ids,
        filter: JSON.stringify(this.filter)
      });
    },

    filterRegion() {
      var numeric_array = [];
      for (var item in this.filter.selectedWilayas) {
        numeric_array.push(this.filter.selectedWilayas[item]);
      }
      this.$store.dispatch("fetchCommunes", {
        filter: numeric_array,
      });
    },
    setUsers(users, ids, filter) {
      if (users != null) {
        this.selectedUsers = users;
        this.filtredUsers = users;
      } else {
        this.selectedUsers = [];
        this.filtredUsers = [];
      }

      this.ids = ids;

      if (filter) {
        this.filter = filter;
      }


    },
    comparator(a, b) {
      return a.id == b.id;
    },

    getCountries() {
      this.isCountriesLoading = true;
      HTTP.get("/v1/users/countries")
          .then((res) => {
            this.isCountriesLoading = false;
            this.countries = res.data.data;
          })
          .catch((err) => {
            this.isCountriesLoading = false;
            console.log(err);
          });
    },
    getCategories() {
      this.isCategoryLoading = true;
      HTTP.get("/v1/users/categories")
          .then((res) => {
            this.isCategoryLoading = false;
            this.categories = res.data.data;
          })
          .catch((err) => {
            this.isRoleLoading = false;
            console.log(err);
          });
    },

    getWilayas() {
      this.isWilayasLoading = true;
      HTTP.get("/v1/users/wilayas")
          .then((res) => {
            this.isWilayasLoading = false;
            this.wilayas = res.data.data;
          })
          .catch((err) => {
            this.isWilayasLoading = false;
            console.log(err);
          });
    },
    getRoles() {
      this.isRoleLoading = true;
      HTTP.get("/v1/users/roles")
          .then((res) => {
            this.isRoleLoading = false;
            this.roles = res.data.data;
          })
          .catch((err) => {
            this.isRoleLoading = false;
            console.log(err);
          });
    },
    getDatabases() {
      this.isDBLoading = true;
      HTTP.get("/v1/users/databases")
          .then((res) => {
            this.isDBLoading = false;
            this.databases = res.data.data;
          })
          .catch((err) => {
            this.isDBLoading = false;
            console.log(err);
          });
    },

    getVersions() {
      this.isVersionsLoading = true;
      HTTP.get("/v1/users/versions")
          .then((res) => {
            this.isVersionsLoading = false;
            this.versions = res.data.data;
          })
          .catch((err) => {
            this.isVersionsLoading = false;
            console.log(err);
          });
    },

  },
  computed: {
    wilayas() {
      return this.$store.getters.getWilayas;
    },

    communes() {
      return this.$store.getters.getCommunes;
    },
  },

  mounted() {
  },
};
</script>